@if (
  {
    travellers: searchService.travellerInformation | async,
    favouriteTravellers: userService.favouriteTravellers | async
  };
  as data
) {
  <div class="search_container">
    <form autocomplete="off">
      <!-- Traveller Select, this is always present for all forms, at the top of the form -->
      @if (!showGuestTravellerForm) {
        <div class="traveller">
          @if (showInvokeUser && !cloneTrip) {
            <app-invoke-user></app-invoke-user>
          }
          <ng-container>
            @if (!cloneTrip) {
              <div class="flex-row-container align-items-end pt-2 pb-2">
                <h2 i18n="@@addTravellersLabel" class="add-travellers-header">
                  Add travellers for this itinerary
                </h2>
                <section (mouseleave)="tt.close()" class="container">
                  <button
                    type="button"
                    class="accessible-tooltip-trigger ico ico-info-circle"
                    i18n-ngbTooltip
                    ngbTooltip="Max of 8 Travellers"
                    triggers="manual"
                    #tt="ngbTooltip"
                    (mouseenter)="tt.open()"
                    (focus)="tt.open()"
                    (blur)="tt.close()"
                    (click)="tt.toggle()"
                    aria-label="Max of 8 Travellers"
                  >
                    <span class="visuallyhidden">Max of 8 Travellers</span>
                  </button>
                </section>
              </div>
            } @else {
              <h2 i18n="@@addTravellers" class="add-travellers-header">Add travellers</h2>
              <section (mouseleave)="tt3.close()" class="container">
                <button
                  type="button"
                  class="accessible-tooltip-trigger ico ico-info-circle"
                  i18n-ngbTooltip
                  ngbTooltip="Please search for traveller by email"
                  triggers="manual"
                  #tt3="ngbTooltip"
                  (mouseenter)="tt3.open()"
                  (focus)="tt3.open()"
                  (blur)="tt3.close()"
                  (click)="tt3.toggle()"
                  aria-label="Please search for traveller by email"
                >
                  <span class="visuallyhidden">Please search for traveller by email</span>
                </button>
              </section>
            }
            @if (!cloneTrip) {
              <div class="flex-row-container flex-row-container--v-center flex-column-mobile">
                <label
                  for="search-user-by"
                  class="search-label"
                  i18n="@@searchTravellersSearchUserBy"
                  >Search user by</label
                >
                <mat-radio-group
                  [(ngModel)]="searchTravellersBy"
                  id="search-user-by"
                  aria-label="Search user by"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <mat-radio-button
                    value="email"
                    class="light-primary email-radio-btn"
                    color="primary"
                    i18n="@@searchTravellersByEmail"
                    >Email
                  </mat-radio-button>
                  <div class="surname_wrapper">
                    <mat-radio-button
                      value="name"
                      class="light-primary surname-checkbox"
                      color="primary"
                      i18n="@@searchTravellersBySurname"
                      >Surname
                    </mat-radio-button>
                    <section (mouseleave)="tt2.close()" class="container">
                      <button
                        type="button"
                        class="accessible-tooltip-trigger ico ico-info-circle surname-tooltip-icon"
                        i18n-ngbTooltip="@@surnameFilterTooltip"
                        triggers="manual"
                        (mouseenter)="tt2.open()"
                        (focus)="tt2.open()"
                        (blur)="tt2.close()"
                        (click)="tt2.toggle()"
                        #tt2="ngbTooltip"
                        i18n-aria-label="@@surnameFilterAriaLabel"
                        aria-label="You can filter the results further by adding the first name after the surname (surname, first name)"
                        ngbTooltip="You can filter the results further by adding the first name after the surname (surname, first name)"
                      >
                        <span class="visuallyhidden" i18n="@@surnameFilter"
                          >You can filter the results further by adding the first name after the
                          surname (surname, first name)</span
                        >
                      </button>
                    </section>
                  </div>
                  <mat-radio-button
                    value="employeeNumber"
                    class="light-primary"
                    color="primary"
                    i18n="@@searchTravellersByEmployeeNo"
                    >Employee No.
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            }
            <div
              class="travellers-form"
              [ngClass]="{ 'travellers-form--no-add-myself': !!isAgentBooker }"
            >
              <div class="travellers-select">
                <div
                  class="travellers_container"
                  i18n-ngbTooltip
                  ngbTooltip="Please search for a user to book for using the field above"
                  [disableTooltip]="!isAgentBooker"
                  [ngClass]="{
                    'error-box': !searchService?.isFavouriteSearch && searchService.traveller_error,
                    disabled_traveller_section: isAgentBooker && !userService.bobo
                  }"
                >
                  @if (data.travellers.length === 0) {
                    <span
                      class="traveller_placeholder"
                      tabindex="0"
                      role="button"
                      (click)="showTravellerInput()"
                      aria-controls="traveller-input"
                      [attr.aria-expanded]="!!showTravelerInput"
                      (keydown.enter)="showTravellerInput()"
                      i18n="@@addTravellersSearch"
                      >Search for a traveller</span
                    >
                  }
                  @if (data.travellers.length > 0) {
                    <ul class="selected_travellers">
                      @for (traveller of data.travellers; track traveller; let i = $index) {
                        <li class="flex-row-container flex-row-container--center">
                          @if (!(traveller | checkFrequentTraveller: data.favouriteTravellers)) {
                            <section (mouseleave)="tt.close()" class="container">
                              <span
                                tabindex="0"
                                role="button"
                                (click)="addFrequentTravellers(traveller)"
                                (keydown.enter)="addFrequentTravellers(traveller)"
                                i18n-ngbTooltip
                                ngbTooltip="Click here to add traveller as a frequent traveller"
                                triggers="manual"
                                #tt="ngbTooltip"
                                (mouseenter)="tt.open()"
                                (focus)="tt.open()"
                                (blur)="tt.close()"
                                aria-label="Click here to add traveller as a frequent traveller"
                              >
                                <fa-icon
                                  [attr.aria-label]="'Add frequent traveller' + traveller.name"
                                  [icon]="faUserRegular"
                                  class="frequent-button"
                                ></fa-icon>
                                <span class="travelle-wrapper"
                                  >{{ traveller.forename }} {{ traveller.surname }}</span
                                >
                              </span>
                            </section>
                          } @else {
                            <section (mouseleave)="tt1.close()" class="container">
                              <span
                                tabindex="0"
                                i18n-ngbTooltip
                                ngbTooltip="Traveller already added as a frequent traveller"
                                triggers="manual"
                                #tt1="ngbTooltip"
                                (mouseenter)="tt1.open()"
                                (focus)="tt1.open()"
                                (blur)="tt1.close()"
                                tabindex="0"
                                aria-label="Traveller already added as a frequent traveller"
                              >
                                <fa-icon
                                  [attr.aria-label]="'Frequent traveller' + traveller.name"
                                  [icon]="faUserSolid"
                                  class="frequent-button"
                                ></fa-icon>
                                <span class="travelle-wrapper"
                                  >{{ traveller.forename }} {{ traveller.surname }}</span
                                >
                              </span>
                            </section>
                          }
                          @if (
                            (i !== 0 || showRemoveUserButton) &&
                            (userService.bobo?.id !== traveller.id || isAgentBooker)
                          ) {
                            <i
                              class="ico-cancel"
                              tabindex="0"
                              role="button"
                              [attr.aria-label]="'Remove traveller ' + traveller.name"
                              id="removetraveller-button-{{ i }}"
                              (click)="removeTraveller(traveller); $event.stopPropagation()"
                              (keydown.enter)="removeTraveller(traveller); $event.stopPropagation()"
                            ></i>
                          }
                        </li>
                      }
                    </ul>
                  }
                  @if (
                    data.travellers.length > 0 &&
                    !isSelfBooker &&
                    (isMe || userService.useAgentCanBookFor()) &&
                    !currentNoOfTravellersGreaterOrEqualToMax
                  ) {
                    <span
                      tabindex="0"
                      role="button"
                      class="additional_passeger_message"
                      aria-controls="traveller-input"
                      [attr.aria-expanded]="showTravelerInput"
                      (click)="showTravellerInput()"
                      (keydown.enter)="showTravellerInput()"
                      i18n="@@addTravellersAddAdditional"
                    >
                      Add additional passengers</span
                    >
                  }
                </div>
                <div id="traveller-input" class="traveller_input" [hidden]="!showTravelerInput">
                  <label for="name" id="add_travs_name_label">
                    <span i18n="@@TravellerSearch">Traveller Search</span>
                  </label>
                  <i class="ico-search" aria-hidden="true"></i>
                  <input
                    autocomplete="off"
                    autofocus
                    type="text"
                    #input
                    id="name"
                    [attr.aria-expanded]="travellerResults.length > 0"
                    attr.aria-controls="name__listbox"
                    aria-autocomplete="list"
                    [disabled]="currentNoOfTravellersGreaterOrEqualToMax"
                    attr.aria-describedby="name__assistiveHint"
                    name="travellerInput"
                    [formControl]="travellerControl"
                    class="traveller_add_input"
                    (keydown.arrowdown)="moveArrowDownToListbox()"
                    (keydown.esc)="resetValue()"
                    tabindex="0"
                  />
                  @if (loadingTravellers) {
                    <i class="traveller_spinner"></i>
                  }
                </div>
                <span
                  id="name__assistiveHint"
                  class="visuallyhidden"
                  i18n="@@WhenAutocompleteResults"
                >
                  When autocomplete results are available use up and down arrows to review and enter
                  to select.
                </span>
                @if (travellerResults.length && showTravelerDropdown) {
                  <span
                    class="visuallyhidden"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                    i18n="@@FoundTravellers"
                  >
                    Found {{ travellerResults.length }}
                    {{ travellerResults.length === 1 ? 'traveller' : 'travellers' }}.
                  </span>
                }
                @if (loadingTravellers && travellerControl.value.lengt < 2) {
                  <span
                    class="visuallyhidden"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                    i18n="@@AtLeast2Characters"
                  >
                    Please enter at least 2 characters.
                  </span>
                }
                <ul
                  class="traveller_options"
                  id="name__listbox"
                  aria-labelledby="add_travs_name_label"
                  role="listbox"
                  [hidden]="travellerResults.length <= 0 || !showTravelerDropdown"
                >
                  @for (result of travellerResults; track result; let i = $index) {
                    <li
                      (click)="addToTravellerSelection(result)"
                      (keydown.enter)="addToTravellerSelection(result)"
                      (keydown.arrowdown)="moveArrowDown($event, i)"
                      (keydown.arrowup)="moveArrowUp($event, i)"
                      (keydown.esc)="resetValue()"
                      tabindex="0"
                      id="name__option--{{ i }}"
                      [attr.aria-posinset]="i"
                      [attr.aria-setsize]="travellerResults.length"
                      role="option"
                    >
                      {{ result.surname }}, {{ result.forename }} {{ result.email }}
                    </li>
                  }
                </ul>
                <ul
                  class="traveller_options"
                  aria-live="polite"
                  role="status"
                  aria-atomic="true"
                  [hidden]="
                    loadingTravellers ||
                    travellerControl.value.length < 3 ||
                    travellerResults.length > 0 ||
                    !showTravelerDropdown
                  "
                >
                  <li i18n="@@addTravellersNoResults">No Results found</li>
                </ul>
                @if (
                  data.travellers.length > 0 &&
                  searchService?.search_objects[serviceType.Flight]?.chosen &&
                  ermCompanyType
                ) {
                  <div class="erm-traveller-type-container triple-radio-buttons">
                    <div
                      class="erm-traveller-type-item"
                      (click)="changedTravellerType(ermTravellerType.Joiner)"
                    >
                      <input
                        type="checkbox"
                        name="Joiner"
                        [checked]="searchService.ermTravellerType === ermTravellerType.Joiner"
                      />
                      <div
                        rel="icon"
                        type="image/x-icon"
                        [ngClass]="{
                          'erm-traveller-type-img-ship':
                            ermCompanyType === CompanyType.CruiseLine ||
                            ermCompanyType === CompanyType.Marine,
                          'erm-traveller-type-img-rig': ermCompanyType === CompanyType.OilGas,
                          'erm-traveller-type-img-windmill':
                            ermCompanyType === CompanyType.Mining ||
                            ermCompanyType === CompanyType.Wind
                        }"
                      ></div>
                      <button
                        [class]="
                          searchService.ermTravellerType === ermTravellerType.Joiner
                            ? 'selected-traveller-type-button'
                            : 'unselected-traveller-type-button'
                        "
                        i18n="@@FlightSearchJoiner"
                      >
                        Joiner
                      </button>
                    </div>
                    <div
                      class="erm-traveller-type-item"
                      (click)="changedTravellerType(ermTravellerType.Leaver)"
                    >
                      <input
                        type="checkbox"
                        name="Leaver"
                        [checked]="searchService.ermTravellerType === ermTravellerType.Leaver"
                      />
                      <div
                        rel="icon"
                        type="image/x-icon"
                        [ngClass]="{
                          'erm-traveller-type-img-ship':
                            ermCompanyType === CompanyType.CruiseLine ||
                            ermCompanyType === CompanyType.Marine,
                          'erm-traveller-type-img-rig': ermCompanyType === CompanyType.OilGas,
                          'erm-traveller-type-img-windmill':
                            ermCompanyType === CompanyType.Mining ||
                            ermCompanyType === CompanyType.Wind
                        }"
                      ></div>
                      <button
                        [class]="
                          searchService.ermTravellerType === ermTravellerType.Leaver
                            ? 'selected-traveller-type-button'
                            : 'unselected-traveller-type-button'
                        "
                        i18n="@@FlightSearchLeaver"
                      >
                        Leaver
                      </button>
                    </div>
                  </div>
                }
              </div>
              <div class="guest-button">
                @if (!isAgentBooker) {
                  <div class="row">
                    <button
                      type="button"
                      appButton="small"
                      class="small-button--left-margin small-button--mobile-margin"
                      i18n-ngbTooltip
                      ngbTooltip="Please search for a user to book for using the field above"
                      [disableTooltip]="!isAgentBooker"
                      (click)="addCurrentUser()"
                      id="add-myself-as-traveller-button"
                      [disabled]="!canAddSelf || (isAgentBooker && !userService.bobo)"
                      aria-label="Add Myself as Traveller"
                      triggers="manual"
                      #ttMyself="ngbTooltip"
                      (mouseenter)="ttMyself.open()"
                      (focus)="ttMyself.open()"
                      (blur)="ttMyself.close()"
                    >
                      @if (!loadingCurrUser) {
                        <i aria-hidden="true" class="ico ico-user add-me-icon"></i>
                      }
                      @if (!loadingCurrUser) {
                        <span i18n="@@addTravellersAddMe">Add Myself as Traveller</span>
                      }
                      @if (loadingCurrUser) {
                        <app-loading-spinner size="sm" />
                      }
                    </button>
                  </div>
                  <span class="traveller_buttons_separator">&nbsp;</span>
                }
                @if (!isDTD && (canAddGuest || isAgentBooker)) {
                  <div class="row">
                    @if ((userCanBookOthers && allowAddGuest) || (isSelfBooker && allowAddGuest)) {
                      <button
                        type="button"
                        i18n-ngbTooltip
                        ngbTooltip="Please search for a user to book for using the field above"
                        [disableTooltip]="!isAgentBooker"
                        appButton="small"
                        class="small-button--left-margin small-button--mobile-margin"
                        (click)="showGuestTravellerFormToggle()"
                        [disabled]="
                          currentNoOfTravellersGreaterOrEqualToMax ||
                          (isAgentBooker && !userService.bobo)
                        "
                        tabindex="0"
                        (keydown.enter)="showGuestTravellerFormToggle()"
                        aria-label="Add Guest"
                        triggers="manual"
                        #tt4="ngbTooltip"
                        (mouseenter)="tt4.open()"
                        (focus)="tt4.open()"
                        (blur)="tt4.close()"
                      >
                        <i class="ico ico-new-user" aria-hidden="true"></i>
                        <span i18n="@@addTravellersAddGuest">Add Guest</span>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
            @if (isSelfBooker) {
              <span class="visuallyhidden" role="alert"
                >Please note this is a SELFBOOK user therefore your travellers are preselected,
                SELFBOOK users may not add extra travellers to their search.</span
              >
            }
          </ng-container>
          <div class="half-container flex-row-container">
            <div class="half-block">
              @if (canUseTravellerProfile) {
                <mat-checkbox
                  class="light-primary"
                  [(ngModel)]="userService.useTravellerProfile"
                  i18n="@@AddTravellerUseTravellerProfile"
                  (ngModelChange)="updateUseTravellerProfile()"
                  [ngModelOptions]="{ standalone: true }"
                  >Use traveller's policy</mat-checkbox
                >
              }
            </div>
          </div>
        </div>
      }
      @if (showGuestTravellerForm) {
        <div class="booking_panel_options">
          <button
            class="guest_back_arrow"
            (click)="showGuestTravellerFormToggle()"
            tabindex="0"
            aria-label="Back"
          >
            <i class="ico ico-arrow-left" aria-hidden="true"></i>
            <span i18n="@@addTravellersBack">Back</span>
          </button>
          <div class="content-centre flex-column-container">
            <i class="ico ico-new-user header_icon"></i>
            <h2 class="guest_header_text text-center" i18n="@@addTravellersAddGuestHeading">
              Add a guest traveller to your trip
            </h2>
          </div>
        </div>
      }
      @if (showGuestTravellerForm) {
        <app-guest-traveller-form
          [ngClass]="{ 'clone-trip': cloneTrip }"
          [selectedTravellers]="data.travellers"
          (guest)="addGuest($event)"
        ></app-guest-traveller-form>
      }
    </form>
  </div>
}
